/* Bijoumani — pages collections (filtres Shopify en AJAX, tri, densité, « Afficher plus »).
   Reprend le comportement de js/shop.js de la maquette, sur les vrais filtres Shopify. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = $('[data-bm-coll]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const sid = root.dataset.sectionId;
  const SWAPS = ['head', 'act', 'side', 'sheet', 'bar', 'grid', 'more', 'none'];
  let dens = 4, io = null, busy = false;
  try { dens = +(sessionStorage.getItem('bjm2-g') || 4); } catch (e) {}

  const metalRefresh = () => dispatchEvent(new CustomEvent('metal', { detail: document.documentElement.dataset.metal === 'argent' ? 'argent' : 'or' }));
  const gridEl = () => $('[data-bm-swap="grid"]', root);

  function markPrice() {
    const q = new URL(location.href).searchParams;
    $$('fieldset[data-f="p"]', root.ownerDocument).forEach(fs => {
      const g = q.get(fs.dataset.pmin), l = q.get(fs.dataset.pmax);
      $$('.ck', fs).forEach(b => {
        const bg = b.dataset.gte, bl = b.dataset.lte;
        const on = (g !== null || l !== null) && (bg ? +g === +bg : g === null) && (bl ? +l === +bl : l === null);
        b.classList.toggle('on', !!on);
      });
    });
  }
  function density() {
    const g = gridEl(); if (g) g.classList.toggle('g2', dens === 2);
    $$('.dn button').forEach(b => b.classList.toggle('on', +b.dataset.g === dens));
  }
  function animate(from) {
    const g = gridEl(); if (!g) return;
    $$('.pc', g).slice(from, from + 15).forEach((c, i) => { c.classList.add('in'); c.style.setProperty('--d', i * 30 + 'ms'); });
  }
  function watch() {
    if (io) io.disconnect();
    const m = $('[data-bm-swap="more"]', root);
    if (m && $('a#more', m)) {
      io = new IntersectionObserver(([e]) => { if (e.isIntersecting) more(); }, { rootMargin: '700px 0px' });
      io.observe(m);
    }
  }
  function top() {
    const t = $('.sp-g', root); if (!t) return;
    const y = t.getBoundingClientRect().top + scrollY - 150;
    if (scrollY > y) scrollTo({ top: y, behavior: 'smooth' });
  }

  async function fetchDoc(href) {
    const u = new URL(href, location.origin);
    u.searchParams.set('section_id', sid);
    const r = await fetch(u.toString(), { headers: { 'X-Requested-With': 'fetch' } });
    if (!r.ok) throw new Error(r.status);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const nr = $('[data-bm-coll]', doc);
    if (!nr) throw new Error('no root');
    return nr;
  }

  async function go(href, push = true) {
    if (busy) return; busy = true; root.classList.add('is-loading');
    try {
      const nr = await fetchDoc(href);
      SWAPS.forEach(k => { const a = $(`[data-bm-swap="${k}"]`, root), b = $(`[data-bm-swap="${k}"]`, nr); if (a && b) a.replaceWith(b); });
      const u = new URL(href, location.origin); u.searchParams.delete('section_id');
      if (push) history.pushState(null, '', u.pathname + u.search);
      document.title = nr.dataset.title || document.title;
      density(); markPrice(); animate(0); watch(); metalRefresh();
    } catch (e) { location.href = href; return; }
    busy = false; root.classList.remove('is-loading');
  }

  async function more() {
    const a = $('a#more', root); if (!a || busy) return;
    busy = true; a.classList.add('is-busy');
    try {
      const nr = await fetchDoc(a.getAttribute('href'));
      const g = gridEl(), start = $$('.pc', g).length;
      g.insertAdjacentHTML('beforeend', $('[data-bm-swap="grid"]', nr).innerHTML);
      const a2 = $('[data-bm-swap="more"]', root), b2 = $('[data-bm-swap="more"]', nr);
      if (a2 && b2) a2.replaceWith(b2);
      animate(start); watch(); metalRefresh();
    } catch (e) { location.href = a.getAttribute('href'); return; }
    busy = false;
  }

  document.addEventListener('click', e => {
    if (!root.isConnected) return;
    const ck = e.target.closest('.ck[data-href]');
    if (ck && !ck.disabled) { e.preventDefault(); go(ck.dataset.href).then(top); return; }
    const pk = e.target.closest('fieldset[data-f="p"] .ck');
    if (pk) {
      e.preventDefault();
      const fs = pk.closest('fieldset'), u = new URL(location.href);
      const was = pk.classList.contains('on');
      u.searchParams.delete(fs.dataset.pmin); u.searchParams.delete(fs.dataset.pmax); u.searchParams.delete('page');
      if (!was) { if (pk.dataset.gte) u.searchParams.set(fs.dataset.pmin, pk.dataset.gte); if (pk.dataset.lte) u.searchParams.set(fs.dataset.pmax, pk.dataset.lte); }
      go(u.pathname + u.search).then(top); return;
    }
    const rm = e.target.closest('.act [data-href]');
    if (rm) { e.preventDefault(); go(rm.dataset.href); return; }
    const cl = e.target.closest('[data-bm-clear]');
    if (cl) { e.preventDefault(); go(cl.getAttribute('href')).then(top); return; }
    const mo = e.target.closest('a#more');
    if (mo) { e.preventDefault(); more(); return; }
    const dn = e.target.closest('.dn [data-g]');
    if (dn) { dens = +dn.dataset.g; try { sessionStorage.setItem('bjm2-g', dens); } catch (er) {} density(); }
  });

  document.addEventListener('change', e => {
    const s = e.target.closest('select[data-bm-sort]'); if (!s || !root.isConnected) return;
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    go(u.pathname + u.search);
  });
  addEventListener('popstate', () => { if (root.isConnected) go(location.pathname + location.search, false); });

  density(); markPrice(); watch();
})();